import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-540f7ba4")

_pushScopeId("data-v-540f7ba4")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "week-checkbox" }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { class: "width60per" }
const _hoisted_6 = {
  key: 0,
  class: "status-on"
}
const _hoisted_7 = {
  key: 1,
  class: "status-off"
}
const _hoisted_8 = { class: "text-align-left" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "height20px" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_sec_date_picker = _resolveComponent("sec-date-picker")
  const _component_el_time_picker = _resolveComponent("el-time-picker")
  const _component_el_form = _resolveComponent("el-form")
  const _component_list = _resolveComponent("list")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "set-page-form-width",
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.DeviceDetailDetailUnitName,
            prop: "Build"
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.Build,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Build = $event))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.key,
                      value: item.key,
                      label: item.value
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.formData.Build)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _ctx.$wordList.RDeviceSearchLabelRoomName,
                prop: "Room"
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.formData.Room,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Room = $event))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aptOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: item.key,
                          value: item.key,
                          label: item.value
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPersonUserInHtmlName,
            prop: "Description"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Description,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.Description = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextIdNumber,
            prop: "IDNumber"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.IDNumber,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.IDNumber = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextRepeats
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.SchedulerType,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.SchedulerType = $event))
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.repeatOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.formData.SchedulerType === _ctx.access.weekly)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _ctx.$wordList.NavInHtmlDay,
                prop: "DateFlag"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.formData.DateFlag,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.DateFlag = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_2, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.access.weekList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            class: "min-width100px",
                            key: index,
                            label: index.toString()
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.formData.SchedulerType === _ctx.access.neverEachCounts)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TabelExpretimeBoxSpecificTime,
                  prop: "ExpireTime"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_sec_date_picker, {
                      modelValue: _ctx.formData.ExpireTime,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.ExpireTime = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.EachDoorCounts,
                  prop: "Allow"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.Allow,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.Allow = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TmpKeyManageListTanleBeginTime,
                  prop: "StartTime"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_time_picker, {
                      modelValue: _ctx.formData.StartTime,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.StartTime = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$wordList.TabelTmpKeyInHtmlEndTime,
                  prop: "StopTime"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_time_picker, {
                      modelValue: _ctx.formData.StopTime,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.StopTime = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPropertyManageEmail,
            prop: "Delivery"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Delivery,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.Delivery = $event)),
                placeholder: _ctx.$wordList.TabelPropertyManageEmail
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextAccessDevice,
            prop: "MAC"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_list, {
          headers: _ctx.headers,
          action: false,
          "show-check": false,
          "request-data": _ctx.requestData,
          update: _ctx.update,
          "deal-list": _ctx.dealList
        }, {
          StatusSlot: _withId((data) => [
            (data.scope.Status === _ctx.access.statusOn.toString())
              ? (_openBlock(), _createBlock("div", _hoisted_6))
              : _createCommentVNode("", true),
            (data.scope.Status === _ctx.access.statusOff.toString())
              ? (_openBlock(), _createBlock("div", _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          RelaySlotHeader: _withId((data) => [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.allCheck,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.allCheck = $event)),
              onChange: _ctx.changeAllCheck
            }, null, 8, ["modelValue", "onChange"]),
            _createTextVNode(" " + _toDisplayString(data.scope.label), 1)
          ]),
          RelaySlot: _withId((data) => [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_el_checkbox_group, {
                modelValue: _ctx.checkArray[data.scope.MAC].Relay,
                "onUpdate:modelValue": ($event: any) => (_ctx.checkArray[data.scope.MAC].Relay = $event),
                onChange: _ctx.choose
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.scope.Relay, (checkItem) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      class: "margin-right10px",
                      label: checkItem.key,
                      key: checkItem.key
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(checkItem.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
            ])
          ]),
          _: 1
        }, 8, ["headers", "request-data", "update", "deal-list"])
      ]),
      _hoisted_9,
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.submit
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})